//@ts-check
import { Grid } from '@material-ui/core'
import React from 'react'


/**
 * @typedef {Object} InteractiveItemProps
 * @property {React.ReactNode} children - The child elements to be rendered inside the InteractiveItem.
 */

/**
 * @param {import('@material-ui/core').GridProps & InteractiveItemProps} props
 */
const InteractiveItem = ({ children, ...props }) => {
    return (
        <Grid {...props} item xs={12}>
            {children}
        </Grid>
    )
}

export default InteractiveItem